import { Modal } from '@spo/storybook';
import { VpButton } from '@vtmn-play/react';
import { useTranslation } from 'react-i18next';

export interface MassEditStatusWarningModal {
  validate: () => void;
  cancel: () => void;
  isOpen: boolean;
}

export const MassEditStatusWarningModal = ({
  validate,
  cancel,
  isOpen,
}: MassEditStatusWarningModal) => {
  const { t } = useTranslation();

  const footerModal = (
    <>
      <VpButton
        onClick={cancel}
        shape="squared"
        variant="secondary"
        aria-label="cancel action"
        data-testid="modal-warning-cancel"
      >
        {t('cancel')}
      </VpButton>
      <VpButton
        onClick={validate}
        shape="squared"
        variant="primary"
        aria-label="confirm action"
        data-testid="modal-warning-confirm"
      >
        {t('yes')}
      </VpButton>
    </>
  );

  return (
    <Modal
      dataTestid="modal-mass-edit-warning"
      footer={footerModal}
      title={t(`mass-edit.modal_warning_title`)}
      ariaLabel="Mass Edit Status Warning Modal"
      isClosable={false}
      closeOnClickOutside={false}
      isOpen={isOpen}
    >
      <div
        className="modal-warning-message"
        data-testid="modal-warning-message"
      >
        <div>
          {t('mass-edit.modal_warning_message.description')}
          <ul>
            <li>{t('mass-edit.modal_warning_message.list_characteristics')}</li>
            <li>{t('mass-edit.modal_warning_message.list_label')}</li>
          </ul>
        </div>
        <div>{t('mass-edit.modal_warning_bold_message')}</div>
        <div>{t('mass-edit.modal_warning_confirmation')}</div>
      </div>
    </Modal>
  );
};
